import { 
  NEWSLETTER_SIGNUP, 
  PROVINCE_CLICKED,
  SOCIAL_CLICKED, 
  AGE_GATE_COOKIE
} from "../constants"

export const newsletterSignup = () => {
  return {
    type: NEWSLETTER_SIGNUP,
    meta: {
      googleAnalytics: {
        category: "Contacts",
        action: "Newsletter Signed Up"
      }
    }
  }
}

export const provinceClicked = province => {
  return {
    type: PROVINCE_CLICKED,
    meta: {
      googleAnalytics: {
        category: "User Interactions",
        action: `clicked`,
        label: `Province ${province} selected`,
        value: province
      }
    }
  }
}

export const socialClicked = social => {
  return {
    type: SOCIAL_CLICKED,
    meta: {
      googleAnalytics: {
        category: "Social Media",
        action: `clicked`,
        label: `${social} clicked`
      }
    }
  }
}


export const storeAgeGate = store => {
  return {
    type: AGE_GATE_COOKIE,
    store: store,
    meta: {
      googleAnalytics: {
        category: "Authentication",
        action: `passed`,
        label: `Age gate cookie stored`
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/gtmActions.js